import { statusLabels, type LeadStatus } from '../lib/types';

interface StatusBadgeProps {
  status: LeadStatus;
  suppressed?: boolean;
}

export function StatusBadge({ status, suppressed }: StatusBadgeProps) {
  return (
    <span className={`status-badge status-${status}`} title={suppressed ? 'Suppressed' : statusLabels[status]}>
      <span aria-hidden="true" />
      {statusLabels[status]}
    </span>
  );
}

